import * as Types from '../../types/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PrinterSetupGetShopClients = gql`
    query PrinterSetupGetShopClients($shopId: uuid!) {
  shopClient(
    where: {shopId: {_eq: $shopId}, _or: [{roles: {_eq: "shop,shop_admin"}}, {roles: {_eq: "shop_admin,shop"}}]}
  ) {
    shopClientId
    name
    email
    shopId
  }
}
    `;
export type PrinterSetupGetShopClientsQueryVariables = Types.Exact<{
  shopId: Types.Scalars['uuid'];
}>;


export type PrinterSetupGetShopClientsQuery = (
  { __typename?: 'query_root' }
  & { shopClient: Array<(
    { __typename?: 'shopClient' }
    & Pick<Types.ShopClient, 'shopClientId' | 'name' | 'email' | 'shopId'>
  )> }
);


export const PrinterSetupGetShopClientsDocument = gql`
    query PrinterSetupGetShopClients($shopId: uuid!) {
  shopClient(
    where: {shopId: {_eq: $shopId}, _or: [{roles: {_eq: "shop,shop_admin"}}, {roles: {_eq: "shop_admin,shop"}}]}
  ) {
    shopClientId
    name
    email
    shopId
  }
}
    `;

/**
 * __usePrinterSetupGetShopClientsQuery__
 *
 * To run a query within a React component, call `usePrinterSetupGetShopClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrinterSetupGetShopClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrinterSetupGetShopClientsQuery({
 *   variables: {
 *      shopId: // value for 'shopId'
 *   },
 * });
 */
export function usePrinterSetupGetShopClientsQuery(baseOptions: Apollo.QueryHookOptions<PrinterSetupGetShopClientsQuery, PrinterSetupGetShopClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrinterSetupGetShopClientsQuery, PrinterSetupGetShopClientsQueryVariables>(PrinterSetupGetShopClientsDocument, options);
      }
export function usePrinterSetupGetShopClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrinterSetupGetShopClientsQuery, PrinterSetupGetShopClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrinterSetupGetShopClientsQuery, PrinterSetupGetShopClientsQueryVariables>(PrinterSetupGetShopClientsDocument, options);
        }
export type PrinterSetupGetShopClientsQueryHookResult = ReturnType<typeof usePrinterSetupGetShopClientsQuery>;
export type PrinterSetupGetShopClientsLazyQueryHookResult = ReturnType<typeof usePrinterSetupGetShopClientsLazyQuery>;
export type PrinterSetupGetShopClientsQueryResult = Apollo.QueryResult<PrinterSetupGetShopClientsQuery, PrinterSetupGetShopClientsQueryVariables>;